// built-in imports
import { motion } from "framer-motion";
import { FaCity, FaMobile } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FormattedMessage } from "react-intl";

// internal imports
import Wrapper from "./contact-info-component.styles";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import { textVariant } from "../../utils/motion/motion.utils";

const textParentAni = {
  hidden: {
    opacity: 0,
  },
  inViewVisible: {
    delay: 0.5,
    opacity: 1,
    transition: {
      type: "stween",
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};
const textAni = {
  hidden: {
    opacity: 0,
    x: "-20vh",
  },
  inViewVisible: {
    x: 0,
    opacity: 1,
  },
};

const infos = [
  {
    id: 1,
    name: "Brunsbutteler Damm 291A, 13591 Berlin",
  },
  {
    id: 2,
    name: "(+49) 015906494127",
  },
  {
    id: 3,
    name: "rasashafiq@gmail.com",
  },
];
const getIcon = (id) => {
  switch (id) {
    case 1:
      return <FaCity className="icon" />;
    case 2:
      return <FaMobile className="icon" />;
    default:
      return <MdEmail className="icon" />;
  }
};
const ContactInfo = () => {
  return (
    <Wrapper>
      <motion.h2 variants={textVariant()} className="lets-talk">
        <FormattedMessage
          id="lets.talk"
          defaultMessage="Let’s talk about your project"
        />
      </motion.h2>
      <motion.dl
        variants={textParentAni}
        viewport={{ once: true }}
        initial="hidden"
        whileInView="inViewVisible"
      >
        {infos.map(({ id, name }) => (
          <motion.div variants={textAni} key={id} className="flex gap-x-4">
            <dt>{getIcon(id)}</dt>
            <h5>{name}</h5>
          </motion.div>
        ))}
      </motion.dl>
    </Wrapper>
  );
};

export default sectionWrapper(ContactInfo);
